export function readAudioDuration(audio:HTMLAudioElement,signal:AbortSignal):Promise<number>{
  if(signal.aborted)return Promise.reject(new Error('오디오 확인을 취소했습니다.'));
  if(Number.isFinite(audio.duration)&&audio.duration>0)return Promise.resolve(audio.duration);
  return new Promise((resolve,reject)=>{
    const clean=()=>{clearTimeout(timer);audio.removeEventListener('loadedmetadata',loaded);audio.removeEventListener('durationchange',loaded);audio.removeEventListener('error',failed);signal.removeEventListener('abort',aborted);};
    const failed=()=>{clean();reject(new Error('오디오 길이를 확인하지 못했습니다. 다시 시도해 주세요.'));};
    const aborted=()=>{clean();reject(new Error('오디오 확인을 취소했습니다.'));};
    const loaded=()=>{if(Number.isFinite(audio.duration)&&audio.duration>0){clean();resolve(audio.duration);}};
    const timer=setTimeout(failed,20000);
    audio.addEventListener('loadedmetadata',loaded);audio.addEventListener('durationchange',loaded);audio.addEventListener('error',failed);signal.addEventListener('abort',aborted,{once:true});
    audio.load();
  });
}
